<template>
    <div>
        <h1>Register</h1>
        <b-row>
            <b-col>
                I am seeking to register as a(n) :
                <span class="pl-2">
                    <b-button href="/register/cna" variant="primary" role="button">Certified Nurse Aide</b-button>
                </span>
                <span class="pl-2">
                    <b-button href="/register/endorsement" variant="primary" role="button">Interstate Endorsement Candidate</b-button>
                </span>
                <span class="pl-2">
                    <b-button href="/register/provider" variant="primary" role="button">Provider</b-button>
                </span>
            </b-col>
        </b-row>
      <b-row>
        <b-col>
          <div>
            If you were previously certified in Minnesota, moved to another state, and now wish to seek an Interstate Endorsement, select "Certified Nurse Aide" above, you will be able to submit an Interstate Endorsement Application later.
          </div>
        </b-col>
      </b-row>
        <hr/>
        <b-row class="mt-3">
            <b-col>
                If you are a CNA and believe that the name or SSN in the certificate register is incorrect such that you cannot register,
                you will need to submit supporting documentation to correct these before registering.
                If your name has changed since you last certified, you may instead register using the name under which you last certified,
                then use the "Update Name" link in "My Information" to update the name associated with your certificate.
                <p class="pl-2 mt-1">
                    <b-button href="/correct-unclaimed" variant="secondary" role="button">Correct Name, SSN, or DOB</b-button>
                </p>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: "Register.vue",
        created() {
            document.title = "Register - Nurse Aide Registry"
        }
    }
</script>

<style scoped>

</style>